module.exports = __webpack_public_path__ + "images/c8f35bdbcba022e0b7f8762c325ce47f-MAHAHUAL-WHITE.png";